import { cookieExtractor } from "@shared/helpers/cookieExtractor/cookieExtractor";

import { PERSISTED_GROUPS_KEY } from "./constants";

const getPersistedExperimentOverrides = (cookie?: string) => {
  const serializedPersistedOverrides = cookieExtractor([PERSISTED_GROUPS_KEY], cookie);

  if (!serializedPersistedOverrides[PERSISTED_GROUPS_KEY]) {
    return {};
  }

  try {
    const persistedOverrides = JSON.parse(
      decodeURIComponent(serializedPersistedOverrides[PERSISTED_GROUPS_KEY])
    );

    return persistedOverrides;
  } catch {
    // If there's an error parsing the JSON, return an empty object
    // Means that no overrides will be set for experiments
    return {};
  }
};

export { getPersistedExperimentOverrides };
